import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getDiscoverableAgentById } from "@/lib/agents";

export const fetchAgentProfile = createServerFn({ method: "GET" })
	.inputValidator((data: { agentSlug: string }) => data)
	.handler(async ({ data }) => {
		const agent = await getDiscoverableAgentById(data.agentSlug);
		return { agent };
	});

export type AgentProfileData = Awaited<ReturnType<typeof fetchAgentProfile>>;

export const agentProfileQueryOptions = (agentSlug: string) =>
	queryOptions({
		queryKey: ["public-agent", agentSlug] as const,
		queryFn: () => fetchAgentProfile({ data: { agentSlug } }),
		staleTime: 60_000,
	});
